import React from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { setSiteCardsFilters, setSiteCardsVisible } from '../../../../redux/site_card/Actions';

import QuickSelect from './QuickSelect';

const propTypes = {

};

function SiteCardsQuickSelect ({}) {
    const dispatch = useDispatch();
    const dispatchSetSiteCardsVisible = (visible) => dispatch(setSiteCardsVisible(visible));
    const dispatchSetSiteCardsFilters = (filters) => dispatch(setSiteCardsFilters(filters));
    const visible = useSelector(state => state.siteCard.areSiteCardsVisible);
    const filters = useSelector(state => state.siteCard.filters);
    const project = useSelector(state => state.project.currentProject);
    // const autocompleteOptions = useSelector(state => {
    //     const columnFilter = filters.children.find(c => c.field === 'siteCardName');
    //     const autocompleteValue = columnFilter && columnFilter.properties.value;
    //     const siteCards = autocompleteValue ?
    //         state.siteCard.siteCards.filter(siteCard => siteCard.name.includes(autocompleteValue)) :
    //         state.siteCard.siteCards;
    //     return siteCards.map(siteCard => siteCard.name).slice(0, 10);
    // });
    const structure = project && project.structure;

    if (!structure) { return <></>; }

    function toggleSiteCards (e) {
        dispatchSetSiteCardsVisible(!visible);
    }

    function handleSetFilters (systemName, filters) {
        dispatchSetSiteCardsFilters(filters);
    }

    const layer = {
        name: 'My Site Cards',
        system_name: 'project_site_cards',
        description: '',
        styles: [],
        filterConfig: {
            fields: {
                column: {
                    type: 'multiselect',
                    label: 'Column',
                    settings: {
                        listOptions: structure.columnOrder.map(columnId => ({
                            value: columnId.toString(),
                            label: structure.columns[columnId].title,
                            colour: structure.columns[columnId].colour
                        }))
                    }
                },
                siteCardName: {
                    type: 'string',
                    label: 'Name',
                    // settings: {
                    //     autocomplete: true,
                    //     autocompleteOptions: autocompleteOptions
                    // }
                }
            }
        }
    };

    return (
        <QuickSelect
            layer={layer}
            thumbnail={false}
            filters={filters}
            onSetFilters={handleSetFilters}
            isActive={visible}
            onToggleActive={toggleSiteCards}
        />
    );
}

SiteCardsQuickSelect.propTypes = propTypes;

export default SiteCardsQuickSelect;